import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BBService } from 'bookingbug-core-js';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Globals } from 'src/app/globals';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

// Services
import { DataStoreService } from '../../services';
@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {

  constructor(
    private DataStore: DataStoreService,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    private apiService: ApiService,
    globals: Globals
  ) {
    this.globals = globals;
  }

  globals: Globals;
  selectedLocationLat;
  selectedLocationLng;
  bookingAddress;
  checkoutInfo = [];
  store;
  respondeCode;
  param2: string;
  companyChildren = [];
  locationList = [];
  selectedLocation;
  purchase: any;
  loadIssue: boolean;
  client;

  ngOnInit() {
    this.spinner.show();

    const language = this.DataStore.language;

    language === '1' ? this.translate.use("ie") : null;
    
    // Get the response code from the URL
    
    this.respondeCode = this.DataStore.paymentResponse['RESULT'];
    this.apiService.logPaymentExtra(
      this.DataStore.selectedLocation,
      this.DataStore.selectedService,
      this.DataStore.realOrderId,
      {type: 'confirm_page_selected_location', code: `${this.DataStore.selectedLocationID}`}
    );

    // the below is where we think our issue lies with some users having time outs for payments
    BBService.company.query(this.DataStore.selectedLocationID).then(company => {
      this.selectedLocation = company;
      this.DataStore.selectedLocation = this.selectedLocation;
      company.$getAddress().then(async address => {
        try {
          this.DataStore.selectedLocation.address = address;
          this.DataStore.irishAddress = this.DataStore.selectedLocation.extra.irish_address ? this.DataStore.selectedLocation.extra.irish_address.split(',') : '';

          const purchase = this.DataStore.purchase;
          this.DataStore.checkoutData = purchase;

          const companyId = this.DataStore.selectedLocation.id;
          const purchaseId = this.DataStore.checkoutData.long_id;

          this.apiService.logPaymentExtra(
            this.DataStore.selectedLocation,
            this.DataStore.selectedService,
            this.DataStore.realOrderId,
            {type: 'confirm_page_response_code', code: `${this.respondeCode}`}
          );

          if (this.respondeCode == "00") {
            try {
              // Store all the data from the store locally to the componenets
              this.store = this.DataStore;

              this.DataStore.checkoutData.paid = this.DataStore.checkoutData.price;

              let jwtUrl = `${environment.jwtURL}?purchase=${this.DataStore.checkoutData.id}&client=irishpassportservice`;
              if (!environment.production) {
                jwtUrl = `${jwtUrl}&env=staging`;
              }
              
              const token = await this.http.get(jwtUrl, { }).toPromise();

              let url = `${environment.paymentCallBackURL}?purchase=${this.DataStore.checkoutData.id}&company=${companyId}&total=${this.DataStore.total}&client=irishpassportservice&account_type=bookingbug&council=true`;
              if (!environment.production) {
                url = `${url}&env=staging`;
              }

              this.apiService.logPaymentExtra(
                this.DataStore.selectedLocation,
                this.DataStore.selectedService,
                this.DataStore.checkoutData.id,
                {
                  'purchase': this.DataStore.checkoutData,
                  'invoke_url': `${url}`
                }
              );

              this.http.get(url, { }).subscribe(purchase => {
                this.purchase = purchase;
                console.log(this.purchase?.payment_history?._embedded?.payments[0]);
                purchase['_embedded'].bookings.forEach(async booking => {
                  this.checkoutInfo.push(booking);
                });

                // now check the purchase paid amount
                if (purchase['paid'] < 1) {
                  this.apiService.logPaymentExtra(
                    this.DataStore.selectedLocation,
                    this.DataStore.selectedService,
                    this.DataStore.checkoutData.id,
                    {
                      'purchase': this.DataStore.checkoutData,
                      'confirm_page_not_paid': purchase
                    }
                  );

                  this.http.get(url, { }).subscribe(purchase => {
                    this.purchase = purchase;
                    console.log(this.purchase?.payment_history?._embedded?.payments[0]);
                    purchase['_embedded'].bookings.forEach(async booking => {
                      this.checkoutInfo.push(booking);
                    });
                  }, err => {
                    console.log(err);
                    this.loadIssue = true;
                    this.apiService.logPaymentExtra(
                      this.DataStore.selectedLocation,
                      this.DataStore.selectedService,
                      this.DataStore.checkoutData.id,
                      {     
                        'purchase': this.DataStore.checkoutData,
                        'confirm_page_not_paid_error': err
                      }
                    );
                  });
                }

                this.spinner.hide();
              }, err => {
                console.log(err);
                this.apiService.logPaymentExtra(
                  this.DataStore.selectedLocation,
                  this.DataStore.selectedService,
                  this.DataStore.checkoutData.id,
                  {
                    'purchase': this.DataStore.checkoutData,
                    'confirm_page': err
                  }
                );

                this.http.get(url, { }).subscribe(purchase => {
                  this.purchase = purchase;
                  console.log(this.purchase?.payment_history?._embedded?.payments[0]);
                  purchase['_embedded'].bookings.forEach(async booking => {
                    this.checkoutInfo.push(booking);
                  });
                  this.spinner.hide();
                }, err => {
                  this.loadIssue = true;
                  console.log(err);
                  this.apiService.logPaymentExtra(
                    this.DataStore.selectedLocation,
                    this.DataStore.selectedService,
                    this.DataStore.checkoutData.id,
                    {
                      'purchase': this.DataStore.checkoutData,
                      'confirm_page_retry': err
                    }
                  );
                  this.spinner.hide();
                });

              });
            }
            catch (err) {
              this.loadIssue = true;
              console.log(err);
              this.apiService.logPaymentExtra(
                this.DataStore.selectedLocation,
                this.DataStore.selectedService,
                this.DataStore.checkoutData.id,
                {
                  'purchase': this.DataStore.checkoutData,
                  'confirm_page_error': {'msg': err.message, 'line': err.lineNumber}
                }
              );
              this.spinner.hide();
            }
          } 
        }
        catch (err) {
          this.loadIssue = true;
          console.log(err);
          this.apiService.logPaymentExtra(
            this.DataStore.selectedLocation,
            this.DataStore.selectedService,
            this.DataStore.checkoutData.id,
            {
              'purchase': this.DataStore.checkoutData,
              'confirmation_page_post_location_error': err
            }
          );
          this.spinner.hide();
        }
        
      }, (err) => {
        this.loadIssue = true;
        console.log(err);
        this.apiService.logPaymentExtra(
          this.DataStore.selectedLocation,
          this.DataStore.selectedService,
          this.DataStore.checkoutData.id,
          {
            'purchase': this.DataStore.checkoutData,
            'address_error': err.message
          }
        );
        this.spinner.hide();
      });
    }, (err) => {
      this.loadIssue = true;
      this.apiService.logPaymentExtra(
        this.DataStore.selectedLocation,
        this.DataStore.selectedService,
        this.DataStore.checkoutData.id,
        {
          'purchase': this.DataStore.checkoutData,
          'location_error': err.message
        }
      );
      console.log(err);
      this.spinner.hide();
    });
  }

  generateIcal(booking) {
    let icalData = {
      firstname: '',
      lastname: '',
      ApplicationType: ''
    };

    booking._embedded.answers.forEach(question => {
      if (question.question_id == 23) {
        icalData.firstname = question.value;
      } else if (question.question_id == 22) {
        icalData.lastname = question.value;
      } else if (question.question_id == 11) {
        icalData.ApplicationType = question.value
      }
    });
    const start = booking.datetime.split('.')[0].replace(/-/g, '').replace(/:/g, '');
    const end = booking.end_datetime.split('.')[0].replace(/-/g, '').replace(/:/g, '');
    const desc =
      `Application Reference: ${booking.id}-${booking.purchase_ref}\\n` +
      `Applicant Name: ${icalData.firstname} ${icalData.lastname}\\n` +
      `Application Type: ${icalData.ApplicationType}\\n` +
      `Counter: ${booking.resource_name}\\n`;
    const loc = `${booking.address.address1}, ${booking.address.address4}, ${booking.address.postcode}`;
    const calUrl = `BEGIN:VCALENDAR%0d%0caVERSION:2.0%0d%0aBEGIN:VEVENT%0d%0aUID:ea22b2a397b12a7b2f629720cd46d84e%0d%0aSUMMARY:${booking.service_name}%0d%0aDTSTART;TZID=UTC:${start}%0d%0aDTEND;TZID=UTC:${end}%0d%0aDESCRIPTION:${desc}%0d%0aLOCATION:${loc}%0d%0aEND:VEVENT%0d%0aEND:VCALENDAR%0d%0a`;
    const fullUrl = `data:text/calendar;harset=utf8,${calUrl}`;

    window.open(fullUrl);
  }

  print() {
    // This is placed here rather then on the btn function to stop the
    // "Property 'window' does not exist on type 'ConfirmationComponent'" message
    window.print();
  }

}
